export default __webpack_public_path__ + "static/media/reactjs.c2861c4d.png";